import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { Form } from 'react-bootstrap';

const FilterAccordion = ({ filterOptions, setFilterOptions, title, handleApplyFilters }) => {
  const [expand, setExpand] = useState(false);

  const handleClearFilters = (e) => {
    e.stopPropagation();
    setFilterOptions(fo => fo.map(f => ({ ...f, isChecked: false })));
    if (filterOptions.find(f => f.isApplied)) {
      handleApplyFilters(title);
    }
  };

  return (
    <>
      <div className={'d-flex flex-column mb-3'}>
        <div className='filterAccordionTitle' onClick={() => setExpand(!expand)}>
          <h2 style={{ fontSize: 'max(0.8vw, 12px)' }}>{title}</h2>
          <div className='d-flex flex-row gap-2'>
            {filterOptions && filterOptions.filter(q => q.questionsCount >= 1).length >= 1 && filterOptions.filter(q => q.isChecked).length >= 1 && <div className='clearFilterBtn' onClick={(e) => handleClearFilters(e)}>
              <FontAwesomeIcon style={{ fontSize: '16px' }} icon={faCircleXmark} />
              <span>Clear</span>
            </div>}
            <div className={`expandFilterButton ${expand ? 'expanded' : ''}`}><FontAwesomeIcon color='#7085C5' style={{ fontSize: '16px' }} icon={faChevronRight} /></div>
          </div>
        </div>

        <div className={`filterOptions ${expand ? 'expanded' : ''}`}>
          {(!filterOptions || filterOptions.filter(q => q.questionsCount >= 1).length <= 0) && <div>No filters available</div>}
          {filterOptions && filterOptions.filter(q => q.questionsCount >= 1).length >= 1 && filterOptions.map((option, index) => {

            if (option.questionsCount <= 0) return;
            var optionId = `${title.replaceAll(' ', '_')}_${option.stringId ? option.stringId.replaceAll(' ', '_').replaceAll('.', '-') : option.id}`;

            return (
              <Form.Check key={`${title.replaceAll(' ', '_')}_${index}`} type='checkbox' id={optionId} className='filterCheckbox'>
                <Form.Check.Input type='checkbox' style={{ marginRight: '5px' }}
                  id={optionId}
                  checked={option.isChecked}
                  onChange={() => setFilterOptions(filterOptions.map(filter => filter.id == option.id ? { ...filter, isChecked: !filter.isChecked } : filter))} />
                <Form.Check.Label id={`${optionId}_label`}>{`${option.name} (${option.questionsCount})`}</Form.Check.Label>
              </Form.Check>
            );
          })}
        </div>
        <div style={{ border: '1px solid #D4DEFF', marginTop: '.75em' }}></div>
      </div>
    </>
  );
};

FilterAccordion.propTypes = {
  filterOptions: PropTypes.array.isRequired,
  title: PropTypes.string,
  handleApplyFilters: PropTypes.func
};

export default FilterAccordion;